import axios from "axios";
import config from "./../config/config";

export default async function callApi(method, data, enpoint = "services.php") {
  if (method === "get") {
    data.urlParams = config.urlParams;
    data.shop = config.shop;
    return await axios
      .get(`${config.rootLink}${enpoint}`, {
        params: data,
        headers:
          process.env.REACT_APP_ENV === "production"
            ? {
                "Content-Security-Policy": `frame-ancestors https://${data.shop} https://admin.shopify.com`,
              }
            : {
                "content-type": "application/json",
              },
      })
      .catch(function (error) {
        console.log(error);
      });
  } else {
    data.append("urlParams", config.urlParams);
    data.append("shop", config.shop);
    return await axios
      .post(config.rootLink + "services.php", data, {
        headers: {
          "Content-Security-Policy": `frame-ancestors https://${config.shop} https://admin.shopify.com`,
        },
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}
